export default __webpack_public_path__ + "images/30eb7016123856d249bbe679c86aabc5-halloween_tablet.webp";